<template>
  <div class="playlist">
    <v-card
      v-if="invalidParam"
      outlined
      max-width="900"
    >
      <v-card-text class="error--text">
        無効なパラメータです。
      </v-card-text>
    </v-card>
    <template v-else>
      <v-card
        outlined
        max-width="900"
        class="mb-3"
      >
        <v-card-title class="py-3">
          {{ listTitle }}
        </v-card-title>
      </v-card>

      <PostCard
        v-if="firstLoaded && !posts.length"
        no-post
      />
      <PostCard
        v-for="post in posts"
        :key="post.postId"
        :post="post"
        :show-count="false"
      />
      <div
        v-if="!noMorePosts"
        class="load-more"
      >
        <div
          v-if="$_myUserData.isAuthed && !isLoadingPosts"
          v-intersect="loadMorePosts"
        />
        <PostCard
          v-for="i in (!posts.length ? 3 : 1)"
          :key="i"
          loader
          :show-count="false"
        />
      </div>
    </template>
  </div>
</template>

<style lang="scss">
.playlist {
  > * {
    margin: auto;
  }
  .load-more {
    max-width: 900px;
  }
}
</style>

<script>
import firebase from 'firebase/app';
import 'firebase/firestore';

export default {
  data: () => ({
    invalidParam: false,
    posts: [],
    noMorePosts: false,
    firstLoaded: false,
    isLoadingPosts: false
  }),
  computed: {
    listTitle() {
      if (!this.$route.params.listId || this.$route.params.listId === 'favorite') {
        return 'お気に入り';
      }
      return '';
    }
  },
  mounted() {
    if (this.$route.params.listId && this.$route.params.listId !== 'favorite') {
      this.invalidParam = true;
      return setTimeout(() => {
        this.$_createPageTitle({
          title: '404 - midies',
          desc: 'プレイリストが存在しません。'
        });
      }, 100);
    }
    this.$_createPageTitle({ title: 'お気に入り' + ' - midies' });
  },
  methods: {
    async loadMorePosts() {
      this.isLoadingPosts = true;
      let postsRef = firebase.firestore().collection('users').doc(this.$_myUserData.uid).collection('favPosts').orderBy('createdAt', 'desc');
      if (this.posts.length) {
        postsRef = postsRef.startAfter(this.posts.slice(-1)[0].createdAt);
      }
      await postsRef.limit(50).get()
        .then(snapshot => {
          if (snapshot.empty) {
            throw new Error();
          }
          snapshot.forEach(doc => {
            this.posts.push({
              postId: doc.id,
              ...doc.data().postDetails,
              showExplanation: false
            });
          });
        })
        .catch(err => {
          console.error(err);
          this.noMorePosts = true;
        })
        .finally(() => {
          this.isLoadingPosts = false;
          if (!this.firstLoaded) {
            this.firstLoaded = true;
          }
        });
    }
  }
};
</script>
